module.exports = __webpack_public_path__ + "static/media/market.1d2ae647.png";